<ng-container *ngIf="!field.hide">
  <b *ngIf="to.label" class="label">{{to.label}}</b>
  <ng-template #repeatField let-field="field" let-i="i">
      <div [ngClass]="field?.templateOptions?.itemWrapper">
          <formly-group [field]="field"></formly-group>
          <div [ngClass]="field?.templateOptions?.removeButtonClass" *ngIf="
              !field?.templateOptions?.disabled &&
              !field?.templateOptions?.hideButtons && hideRemoveBtn && getFieldGroupLength() > 1; else EmptyBox
            " class="col-sm-2 d-flex align-items-center remove-btn-wrapper">
              <button mat-raised-button *ngIf="!!field?.templateOptions?.removeBtnText; else Default" color="warn"
                  type="button" (click)="remove(i)">{{ field.templateOptions.removeBtnText }}
              </button>
              <ng-template #Default>
                  <button mat-icon-button (click)="remove(i)" [matTooltip]="to.removeButtonTooltip">
                      <mat-icon>delete</mat-icon>
                  </button>
              </ng-template>
          </div>
          <ng-template #EmptyBox>
              <div *ngIf="field?.fieldArray?.templateOptions?.autoRepeat" class="w-10"></div>
          </ng-template>
      </div>
  </ng-template>
  <div class="mb-6 add-btn-wrapper" *ngIf="
          !field?.fieldArray?.templateOptions?.disabled &&
          !hideExpression && hideAddBtn && !field?.fieldArray?.templateOptions?.autoRepeat
        ">
      <button mat-raised-button color="primary" *ngIf="!!field?.fieldArray?.templateOptions?.addBtnText; else Default"
          class="btn btn-primary" type="button" (click)="add()">{{
          field?.fieldArray?.templateOptions?.addBtnText}}
      </button>
      <ng-template #Default>
          <button mat-icon-button (click)="add()" [matTooltip]="to.addButtonTooltip">
              <mat-icon>add_circle_outline </mat-icon>
          </button>
      </ng-template>
  </div>
  <!-- Grouped mode: show N per row if groupRows is true -->
  <div *ngIf="field.fieldArray?.templateOptions?.groupRows; else defaultMode" class="grid grid-cols-3 gap-4">
    <ng-container *ngFor="let chunk of groupedFieldRows">
      <ng-container *ngFor="let field of chunk; let i = index">
        <ng-container *ngTemplateOutlet="repeatField; context: { field: field, i: i }"></ng-container>
      </ng-container>
    </ng-container>
  </div>
  <!-- Default mode: show each field in its own row if groupRows is false or not set -->
  <ng-template #defaultMode>
    <div [ngClass]="field?.templateOptions?.fieldGroupClassName" *ngFor="let field of field.fieldGroup; let i = index">
      <ng-container *ngTemplateOutlet="repeatField; context: { field: field, i: i }"></ng-container>
    </div>
  </ng-template>
</ng-container>
